export const titleAppend = '- CAS Shield';
